import { render, staticRenderFns } from "./CrearPercepcionMaternidad.vue?vue&type=template&id=1ee5484f&scoped=true&"
import script from "./CrearPercepcionMaternidad.vue?vue&type=script&lang=js&"
export * from "./CrearPercepcionMaternidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5484f",
  null
  
)

export default component.exports